import React from 'react';
import { Button } from './Button';
const CHECKOUT_URL = 'https://www.lunaycalma.com/cart/46841754419354:1';
export function HeroSection() {
  return <section className="relative w-full min-h-screen bg-gradient-to-br from-navy-900 via-navy-800 to-magenta-900 text-white overflow-hidden" data-id="element-182">
      {/* Background overlay */}
      <div className="absolute inset-0 bg-black/20" data-id="element-183"></div>

      <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-32" data-id="element-184">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-185">
          {/* Left: Copy */}
          <div className="text-center lg:text-left space-y-8" data-id="element-186">
            <div className="inline-block bg-pink-500/20 backdrop-blur-sm px-4 py-2 rounded-full border border-pink-400/30" data-id="element-187">
              <span className="text-pink-300 text-sm font-semibold" data-id="element-188">
                ✨ Oferta Especial — 2 Bonos GRATIS
              </span>
            </div>

            <h1 className="font-serif text-4xl lg:text-6xl leading-tight" data-id="element-189">
              No Todos Están Listos Para Esto… Pero Tú Sí:{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-gold-400" data-id="element-190">
                Empieza Hoy Tus 30 Noches Para Dormir en Paz
              </span>
            </h1>

            <p className="text-xl lg:text-2xl text-gray-200 leading-relaxed" data-id="element-191">
              Método Latino Emocionalmente Inteligente para Calmar tu Mente y
              Sanar la Ansiedad. Hoy por{' '}
              <strong className="text-gold-400" data-id="element-192">$14.97</strong> e incluye{' '}
              <strong className="text-pink-400" data-id="element-193">2 eBooks GRATIS</strong>.
            </p>

            <div className="space-y-4" data-id="element-194">
              <Button size="lg" className="w-full sm:w-auto" href={CHECKOUT_URL} data-id="element-195">
                Descargar ahora — Acceso inmediato
              </Button>

              <p className="text-sm text-gray-300 flex items-center justify-center lg:justify-start gap-2" data-id="element-196">
                <span className="text-green-400" data-id="element-197">✓</span>
                eBook digital en PDF — Descarga instantánea
              </p>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-6 text-sm text-gray-300 pt-4" data-id="element-198">
              <div className="flex items-center gap-2" data-id="element-199">
                <span className="text-gold-400" data-id="element-200">⭐⭐⭐⭐⭐</span>
              </div>
              <span data-id="element-201">Más de 1,000 mujeres transformadas</span>
            </div>
          </div>

          {/* Right: Hero Image */}
          <div className="relative" data-id="element-202">
            <div className="relative z-10 transform hover:scale-105 transition-transform duration-500" data-id="element-203">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/frud4MZfgNuJRqK3nNtUKy/ChatGPT_Image_2_dic_2025%2C_21_43_14.png" alt="30 Noches para Dormir en Paz - Método Latino Emocionalmente Inteligente para Calmar tu Mente y Sanar la Ansiedad" className="w-full rounded-3xl shadow-2xl" data-id="element-204" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-gold-400 rounded-full blur-3xl opacity-30" data-id="element-205"></div>
            <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-magenta-500 rounded-full blur-3xl opacity-30" data-id="element-206"></div>
          </div>
        </div>
      </div>
    </section>;
}